import { Button, Checkbox, Col, Form, Input, Popconfirm, Row, notification } from 'antd'
import React, { useEffect, useState } from 'react'
import Layout from '../layout/Layout'
import { api } from '../utils/Api';
import axios from 'axios';
import { CustomSpinner } from '../utils/CustomComponents';

const Manager = (props) => {
    const [form] = Form.useForm()
    const [initialValues, setInitialValues] = useState({})
    const [loading, setLoading] = useState(false)
    const [loadingForm, setLoadingForm] = useState(true)
    const [email, setEmail] = useState('')
    const [apiNotification, contextHolder] = notification.useNotification()

    useEffect(() => {
        getManager()
    }, [])

    const openNotification = (type, message, description) => {
        apiNotification[type]({
            message: message,
            description: description
        })
    }

    const duplicatedUserEmail = async (email) => {
        const url = api + '/useremail/' + email
        const token = localStorage.getItem('token')
        axios.defaults.headers.common = { 'Authorization': `Bearer ${token}` }

        try {
            const { data } = await axios.get(url)
            return data.found
        } catch (err) {
            console.error(err.message)
            return null
        }
    }

    const getManager = async () => {
        try {
            let url = api + `/users/${props.match.params.id}` 
            const token = localStorage.getItem('token')
            axios.defaults.headers.common = { 'Authorization': `Bearer ${token}` }

            const { data } = await axios.get(url)

            setInitialValues({
                ...initialValues,
                name: data.name,
                email: data.email,
            })
            setEmail(data.email)
            setLoading(false)
            setLoadingForm(false)

        } catch (err) {
            setLoading(false)
            openNotification('error', 'Error', 'Error while trying to get user')
            console.error(err.message)
            return null
        }
    }

    const updateManager = async (data) => {
        const user = {
            name: data.name,
            email: data.email,
        }

        try {
            let url = api + `/users/${props.match.params.id}` 
            const token = localStorage.getItem('token')
            axios.defaults.headers.common = { 'Authorization': `Bearer ${token}` }

            await axios.patch(url, user)
            openNotification('success', 'Success', 'Manager created')
            setLoading(false)
            props.history.push('/managerlist')

        } catch (err) {
            setLoading(false)
            openNotification('error', 'Error', 'Error while trying to update user')
            console.error(err.message)
            return null
        }
    }

    const deleteManager = async () => {
        setLoading(true)

        const url = api + '/users/' + props.match.params.id
        const token = localStorage.getItem('token')
        axios.defaults.headers.common = { 'Authorization': `Bearer ${token}` }

        try {
            await axios.delete(url)
            openNotification('info', 'Info', 'Manager Deleted')
            setLoading(false)
            props.history.push('/managerlist')
        } catch (err) {
            setLoading(false)
            console.error(err.message)
            return null
        }
    }
    
    const validateUser = async (values) => {
        if(values.email === email){
            updateManager(values)
        }else{
            const duplicadoEmail = await duplicatedUserEmail(values.email)
            
            if (duplicadoEmail) {
                openNotification('warning', 'Duplicated user', 'User already exist with Email')
                setLoading(false)
            }else {
                updateManager(values)
            }
        }
    }

    const onFinish = (values) => {
        setLoading(true)
        validateUser(values)
    }

    const CustomForm = () => {
        return <Form
            form={form}
            layout='vertical'
            initialValues={initialValues}
            onFinish={onFinish}
            >
            <Row gutter={16}>
                <Col span={24}>
                    <Form.Item
                    label='Name'
                    name='name'
                    rules={[
                        {
                            required: true,
                            message: 'Please fill name'
                        }
                    ]}
                    >
                        <Input size='large' />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={24}>
                    <Form.Item
                    label='Email'
                    name='email'
                    rules={[
                        {
                            type: 'email',
                            message: 'The input is not valid E-mail',
                        },
                        {
                            required: true,
                            message: 'Please fill email'
                        }
                    ]}
                    >
                        <Input size='large' />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col>
                    <Button type="primary" htmlType="submit" loading={loading}>
                        Save
                    </Button>
                </Col>
                {/* <Col>
                    <Popconfirm
                        title="Delete the user"
                        description="Are you sure to delete this user?"
                        okText="Yes"
                        cancelText="No"
                        onConfirm={deleteManager}
                    >
                        <Button danger type='primary' htmlType='button' loading={loading}>Delete</Button>
                    </Popconfirm>
                </Col> */}
            </Row>
        </Form>
    }

    return (
        <Layout
        title='Manager'
        description='Edit Manager'
        type='medium'
        >
            {contextHolder}
            {loadingForm ? <CustomSpinner /> : <CustomForm />}
        </Layout>
    )
}

export default Manager